/**
 * @typedef {Object} IconDefinition
 * @property {string} src - the path to the icon.
 */

/**
 * @typedef {Object} IconDefinitions
 * @property {IconDefinition} checkSimple - A simple checkmark icon.
 * @property {IconDefinition} import - An import icon.
 * @property {IconDefinition} export - An export icon.
 * @property {IconDefinition} rewrite - A rewrite icon.
 * @property {IconDefinition} delete - A delete icon.
 */

/** @type {IconDefinitions} */

export const iconDefinitions = {
  checkSimple: {
    src: "/assets/check-simple.svg",
  },
  import: {
    src: "/assets/import-icon.svg",
  },
  export: {
    src: "/assets/export-icon.svg",
  },
  rewrite: {
    src: "/assets/rewrite-icon.svg",
  },
  delete: {
    src: "/assets/delete.svg",
  },
};
